import fetch from "../../../../utils/fetch";
import * as types from "./mutation_types";

const getItems = ({ commit, state, rootState }, page = "feeds") => {
  commit(types.TOGGLE_LOADING);

  // START:CUSTOM - generated
  let token = rootState.auth.token;
  let options = {
    params: {
      itemPerPage: state.itemsPerPage,
      page: state.pageNo,
      q: state.search,
      sort: state.orderBy,
      dir: state.orderDir,
      //TODOs - add filters
    },
  };
  // END:CUSTOM - generated

  fetch(page, options, token)
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ITEMS, data["hydra:member"]);
      commit(types.SET_VIEW, data["hydra:view"]);
      // START:CUSTOM - generated
      commit(types.SET_TOTAL_ITEMS, data["hydra:totalItems"]);
      // END:CUSTOM - generated
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export const getSelectItems = (
  { commit },
  { page = "feeds", params = { properties: ["@id", "name"] } } = {}
) => {
  commit(types.TOGGLE_LOADING);

  fetch(page, { params })
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_SELECT_ITEMS, data["hydra:member"]);
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING);
      commit(types.SET_ERROR, e.message);
    });
};

export default getItems;
